import { Store as ReduxStore, Dispatch as ReduxDispatch } from "redux"

export const SET_VISIBLE_SETTINGS_LIST = "SET_VISIBLE_SETTINGS_LIST"
export const SET_CURRENT_RADIO_BUTTON_LIST_ITEM = "SET_CURRENT_RADIO_BUTTON_LIST_ITEM"
export const UPDATE_DETAIL_SCREEN_OVERLAY_VISIBLE = "UPDATE_DETAIL_SCREEN_OVERLAY_VISIBLE"
export const SET_PREFERENCE_VALUE = "SET_PREFERENCE_VALUE"

export type ReduxInitAction = { type: "@@INIT" }

export type setVisibleSettingsListAction = {
  type: typeof SET_VISIBLE_SETTINGS_LIST
  visibleList: any
}

export type setcurrentRadioButtonListItemAction = {
  type: typeof SET_CURRENT_RADIO_BUTTON_LIST_ITEM
  itemName: string
}

export type updateDetailsScreenOverlayVisibleAction = {
  type: typeof UPDATE_DETAIL_SCREEN_OVERLAY_VISIBLE
  visible: boolean
}

export type setPreferenceValueAction = {
  type: typeof SET_PREFERENCE_VALUE
  key: string,
  value: any
}

export type settingsScreenState = {
  visibleList: any
  currentRadioButtonListItem: string
  detailsScreenOverlayVisible: boolean
}

export type settingsState = {
  [index: string]: any
}

export type Action =
  | ReduxInitAction
  | setVisibleSettingsListAction
  | setcurrentRadioButtonListItemAction
  | updateDetailsScreenOverlayVisibleAction

export type Store = ReduxStore<settingsScreenState, Action>

export type Dispatch = ReduxDispatch<Action>
